import { render, staticRenderFns } from "./LmComment.vue?vue&type=template&id=b24fed54&"
import script from "./LmComment.vue?vue&type=script&lang=js&"
export * from "./LmComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports